module.exports = __webpack_public_path__ + "../resources/img/ic_re_wifi_off_default.83a672b1.svg";